import PropTypes from "prop-types";
export default PropTypes.shape({
	desktop: PropTypes.bool,
	android: PropTypes.bool,
	ios: PropTypes.bool
});
